import { render, staticRenderFns } from "./BuddhistDynamic.vue?vue&type=template&id=68c650e5&scoped=true"
import script from "./BuddhistDynamic.vue?vue&type=script&lang=js"
export * from "./BuddhistDynamic.vue?vue&type=script&lang=js"
import style0 from "./BuddhistDynamic.vue?vue&type=style&index=0&id=68c650e5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c650e5",
  null
  
)

export default component.exports